import React from 'react';
import { NavLink } from 'react-router-dom';
import '../../assets/css/main.css';
import '../../assets/css/adm_custom.css';
import person from '../../assets/img/person.png';

const UserSidebar = ({ items, username }) => {
  return (
    <aside>
      <div className="side_menu_top">
        <div className="side-profile-wrap">
            <i className="side-profile-img"><img src={person} alt=""/></i>
            <div className="side-profile-info">
                <p><b className="profile-name">{username}</b>님</p>
            </div>
        </div>
    </div>
      <div className="side_menu">
        <ul>
          {items.map(item => (
            <li key={item.to}>
              <NavLink 
                to={item.to} 
                className={({ isActive }) => isActive ? 'on' : ''}
              >
                <div>
                  <p>{item.label}</p>
                </div>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
      <div className="logout" onClick={() => {/* TODO: logout */}}>
        <i>❯</i>
        <p>로그아웃</p>
      </div>
    </aside>
  );
};

export default UserSidebar;
